<template>
    <div class="">
        <new-modal title="Enter your Activation Code" size="2xl">
            <template #trigger>
                <slot></slot>
            </template>
            <template #content>
                <div class="">
                    <div class="mb-8">
                        If you’ve received a pre-purchased activation code,
                        please enter it below.
                    </div>

                    <form
                        v-if="!activationCode"
                        class="flex w-full items-start gap-4"
                        @submit.prevent="submitValidation"
                    >
                        <div class="w-full">
                            <form-input
                                v-model="codeValidationForm.activation_code"
                                name="activation_code"
                            ></form-input>
                        </div>
                        <button
                            class="btn btn-primary"
                            :disabled="!codeValidationForm.isDirty"
                        >
                            Apply
                        </button>
                    </form>

                    <div
                        class="mb-8 flex w-full items-center justify-between gap-2"
                        v-else
                    >
                        <div
                            class="flex w-full items-center rounded border p-1"
                        >
                            <div class="w-full px-2">
                                {{ codeValidationForm.activation_code }}
                            </div>
                            <div
                                class="mx-2 my-1 flex items-center gap-2 border-l pl-2"
                            >
                                <svg
                                    width="20"
                                    height="21"
                                    viewBox="0 0 20 21"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <circle
                                        cx="10"
                                        cy="10.5"
                                        r="10"
                                        fill="#0B8753"
                                    />
                                    <path
                                        d="M5.45459 10.843C7.16999 12.0282 9.66512 13.7763 9.66512 14.843C10.4448 12.1763 12.4721 6.66521 14.3435 5.9541"
                                        stroke="white"
                                        stroke-width="1.66667"
                                    />
                                </svg>
                                <div
                                    class="whitespace-nowrap font-medium text-green-300"
                                >
                                    {{ activationCode.days_length }}-day
                                    membership
                                </div>
                            </div>
                        </div>
                        <span class="btn btn-primary opacity-50">Applied</span>
                    </div>
                </div>
                <div v-if="activationCode">
                    <form
                        @submit.prevent="submitRegistration"
                        class="flex flex-col gap-4"
                    >
                        <div class="mb-4 border-b pb-4 font-semibold">
                            Which level are you studying for?
                        </div>
                        <form-radio
                            :options="$page.props.providerLevelOptions"
                            v-model="registrationForm.provider_level_id"
                        ></form-radio>
                        <div class="my-4 border-b pb-4 font-semibold">
                            Create an Account
                        </div>
                        <div class="flex gap-4">
                            <form-input
                                label="First name"
                                v-model="registrationForm.first_name"
                                name="first_name"
                            ></form-input>
                            <form-input
                                label="Last name"
                                v-model="registrationForm.last_name"
                                name="last_name"
                            ></form-input>
                        </div>
                        <div class="flex gap-4">
                            <form-input
                                label="Email"
                                v-model="registrationForm.email"
                                name="email"
                            ></form-input>
                        </div>
                        <div class="flex gap-4">
                            <form-input
                                label="Email confirmation"
                                v-model="registrationForm.email_confirmation"
                                name="email_confirmation"
                            ></form-input>
                        </div>
                        <div class="flex gap-4">
                            <form-input
                                label="Password"
                                type="password"
                                v-model="registrationForm.password"
                                name="password"
                            ></form-input>
                        </div>
                        <div class="flex gap-4">
                            <form-input
                                label="Password confirmation"
                                type="password"
                                v-model="registrationForm.password_confirmation"
                                name="password_confirmation"
                            ></form-input>
                        </div>
                        <div class="flex gap-4">
                            <form-checkbox
                                v-model="registrationForm.agreed_to_terms"
                                label="I have read and agree to the EMTprep Terms and Conditions and Membership Agreement"
                                :checked="registrationForm.agreed_to_terms"
                            ></form-checkbox>
                        </div>
                        <div class="flex gap-4">
                            <form-checkbox
                                v-model="registrationForm.marketing_opt_in"
                                label='I would like to receive EMS updates, related news, and offers from Classward, LLC. <div class="font-xs text-gray-500">Limited emails and we do not sell your information.</div>'
                                :checked="registrationForm.marketing_opt_in"
                            ></form-checkbox>
                        </div>
                        <div class="flex items-end gap-4">
                            <button
                                class="btn btn-primary"
                                :disabled="!registrationForm.isDirty"
                            >
                                Sign Up
                            </button>
                        </div>
                    </form>
                </div>
            </template>
        </new-modal>
    </div>
</template>
<script>
import NewModal from "@/Components/NewModal";
import FormInput from "@/Components/FormInput";
import FormRadio from "@/Components/FormRadio";
import FormCheckbox from "@/Components/FormCheckbox";

export default {
    name: "ActivationCodeModal",
    components: { FormCheckbox, NewModal, FormInput, FormRadio },
    data() {
        return {
            codeValidationForm: this.$inertia.form({
                activation_code: "",
            }),
            registrationForm: this.$inertia.form({
                valid_activation_code: "",
                provider_level_id: "1",
                first_name: "",
                last_name: "",
                email: "",
                email_confirmation: "",
                password: "",
                password_confirmation: "",
                agreed_to_terms: false,
                marketing_opt_in: true,
            }),
            activationCode: null,
            errors: null,
        };
    },
    methods: {
        submitValidation() {
            let vm = this;

            axios
                .post("/activation-code/validate", this.codeValidationForm)
                .then(function (response) {
                    vm.activationCode = response.data;
                    vm.registrationForm.valid_activation_code =
                        response.data.code;
                })
                .catch(function (error) {
                    vm.$page.props.errors["activation_code"] =
                        "Invalid activation code. Please try again.";
                });
        },
        submitRegistration() {
            this.$inertia.post(
                route("activation-code.register-user"),
                this.registrationForm
            );
        },
    },
};
</script>
